import type { SlideProps } from "@/engine/app/offsite-config";

const TILES = [
  { title: "Churn-Prediction", text: "Welche Kunden verlieren wir bald – und warum?" },
  { title: "Verbrauchsprognose", text: "Wie viel brauchen wir morgen, nächste Woche, im Winter?" },
  { title: "Ticket-Vorhersage", text: "Wo entsteht als Nächstes Bedarf – bevor es ruft?" },
];

export function Slide19KIDatalake(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 380,
          height: 380,
          top: "-100px",
          right: "-120px",
          background: "var(--svo-blau)",
          opacity: 0.28,
        }}
      />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 280,
          height: 280,
          bottom: "-60px",
          left: "8%",
          background: "var(--svo-gruen)",
          opacity: 0.12,
          animationDelay: "4s",
        }}
      />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Ausblick</div>
        <h1 className="deck-title rise rise-2">
          Was wäre wenn Datalake + KI <br />
          <span className="accent">zusammenkommen?</span>
        </h1>
      </header>

      <div className="deck-cols3">
        {TILES.map((t, i) => (
          <div key={t.title} className={`col-card rise rise-${i + 4}`}>
            <div className="num">0{i + 1}</div>
            <h4>{t.title}</h4>
            <p>{t.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
